<template>
  <ul class="sub-menu" :class="{ 'd-block': isVisible }">
    <li
      v-for="(child, childIndex) in items"
      :key="childIndex"
      :class="{ active: child.active, open: child.open }"
      @click.capture="handleChildCapture($event, child)"
      @click.stop="handleChildClick(child, childIndex)"
    >
      <router-link :to="child.path" :class="{ 'page-active': child.active }">
        {{ child.name }}
      </router-link>

      <SubMenu
        v-if="child.subItems && child.subItems.length > 0"
        :items="child.subItems"
        :isMobile="isMobile"
        :isVisible="isVisible && (isMobile ? child.open : child.active)"
        @item-click="handleSubItemClick"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: "SubMenu",
  props: {
    items: Array,
    isVisible: Boolean,
    // 与 NavigationMenu 同规则：移动端带下级的项点击只展开，不跳转
    isMobile: Boolean,
  },
  methods: {
    isExpandable(child) {
      return this.isMobile && child.subItems && child.subItems.length > 0;
    },
    // 与 NavigationMenu 同规则：点击来自当前项的下级子菜单时不拦截，
    // 否则三级（叶子）项的点击会被二级项吞掉，导致不跳转
    isFromChildMenu(e) {
      var sm = e.target && e.target.closest ? e.target.closest(".sub-menu") : null;
      return !!sm && e.currentTarget !== sm && e.currentTarget.contains(sm);
    },
    // 捕获阶段拦截 router-link 导航与冒泡，只切换展开态
    handleChildCapture(e, child) {
      if (!this.isExpandable(child)) return;
      if (this.isFromChildMenu(e)) return;
      e.preventDefault();
      e.stopPropagation();
      this.$set(child, "open", !child.open);
      this.$forceUpdate();
    },
    handleChildClick(child, childIndex) {
      this.$emit("item-click", {
        level: 2,
        indexes: [childIndex],
      });
    },
    handleSubItemClick({ level, indexes }) {
      this.$emit("item-click", { level: level + 1, indexes });
    },
  },
};
</script>
<style scoped>
/* @import url("../../assets/css/animate.css");
@import url("../../assets/css/all.css");
@import url("../../assets/css/bootstrap.min.css");
@import url("../../assets/css/boxicons.min.css");
@import url("../../assets/css/bootstrap-icons.css");
@import url("../../assets/css/swiper-bundle.css");
@import url("../../assets/css/nice-select.css");
@import url("../../assets/css/magnific-popup.css");
@import url("../../assets/css/style.css"); */
</style>



// WEBPACK FOOTER //
// src/components/components/SubMenu.vue